import React from 'react';
import { Level } from '../../domain/level';
import { useTranslation } from 'react-i18next';
import { Button } from '../Common/Button';
import { createUseStyles } from 'react-jss';

export interface ILevelSelectionProps {
    levels: Level[];
    onSelectLevel(level: Level): void;
}

const useStyles = createUseStyles({
    list: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    },
});

export const LevelSelection: React.FunctionComponent<ILevelSelectionProps> = props => {
    const styles = useStyles();
    const { t } = useTranslation();

    return (
        <div>
            <ul className={styles.list}>
                {props.levels.map(level => {
                    const name = t(`level.${level.key}.name`);
                    return (
                        <li key={level.key}>
                            <Button onClick={() => props.onSelectLevel(level)}>{name}</Button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
